import { get as _get } from 'lodash'
import { PROJECT_TYPES_MAP, PROJECT_TYPES } from '@/modules/projects/consts'
import dateUtil from '@/utils/dateUtil'
import { projectStatus } from '@/utils/locale'

export function getPurchase (object = {}, defaultValue = {}) {
  const target = object || {}
  const purchase = _get(target, PROJECT_TYPES_MAP[target.numberType])
  return purchase === undefined || purchase === null ? defaultValue : purchase
}

export function getPurchaseAttrFromObject (object = {}, attributeName) {
  return _get(getPurchase(object), attributeName)
}

export function getPurchaseNumber (numberType, object = {}) {
  const target = object || {}
  const number = target.number === undefined || target.number === null ? '' : target.number
  const revisionNum = target.revisionNum === undefined || target.revisionNum === null ? '' : target.revisionNum

  if (numberType === PROJECT_TYPES.PO) {
    return number
  }

  return [number, revisionNum].filter(value => value !== '').join('-')
}

export function validateDlpInCompleted (project) {
  const startOfToday = dateUtil.getTodayStartDateObject()
  return project.dlpDate && new Date(project.dlpDate) >= new Date(startOfToday) && project.status === projectStatus.COMPLETED
}
